require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

var _defineProperty = require("/Users/dom/src/deeplocal/maps-tycoon-2020/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var colors = {
  blue: {
    50: "#e8f0fe",
    100: "#d2e3fc",
    500: "#4285f4",
    600: "#1a73e8",
    700: "#1967d2",
    800: "#185abc",
    900: "#174ea6"
  },
  red: {
    50: "#fce8e6",
    100: "#fad2cf",
    500: "#ea4335",
    600: "#d93025",
    700: "#c5221f",
    800: "#b31412",
    900: "#af0e0e"
  },
  yellow: {
    50: "#fef7e0",
    100: "#feefc3",
    500: "#fbbc04",
    600: "#f9ab00",
    700: "#f29900",
    800: "#ea8600",
    900: "#e37400"
  },
  green: {
    50: "#e6f4ea",
    100: "#ceead6",
    500: "#34a853",
    600: "#1e8e3e",
    700: "#188038",
    800: "#137333",
    900: "#0d652d"
  },
  orange: {
    50: "#feefe3",
    100: "#fedfc8",
    500: "#fa7b17",
    600: "#e8710a",
    700: "#d56e06",
    800: "#c26401",
    900: "#b06000"
  },
  pink: {
    50: "#fde7f3",
    100: "#fdcfe8",
    500: "#f439a0",
    600: "#e52592",
    700: "#d01884",
    800: "#b80672",
    900: "#9c166b"
  },
  purple: {
    50: "#f3e8fd",
    100: "#e9d2fd",
    500: "#a142f4",
    600: "#9334e6",
    700: "#8430ce",
    800: "#7627bb",
    900: "#681da8"
  },
  cyan: {
    50: "#e4f7fb",
    100: "#cbf0f8",
    500: "#24c1e0",
    600: "#12b5cb",
    700: "#129eaf",
    800: "#098591",
    900: "#007b83"
  },
  grey: {
    50: "#f8f9fa",
    100: "#f1f3f4",
    200: "#e8eaed",
    300: "#dadce0",
    400: "#bdc1c6",
    500: "#9aa0a6",
    600: "#80868b",
    700: "#5f6368",
    800: "#3c4043",
    900: "#202124"
  }
}; // add default colors

colors.defaults = {
  blue: colors.blue["600"],
  red: colors.red["500"],
  yellow: colors.yellow["500"],
  green: colors.green["500"],
  orange: colors.orange["500"],
  pink: colors.pink["500"],
  purple: colors.purple["500"],
  cyan: colors.cyan["500"],
  grey: colors.grey["500"]
}; // add american spelling of grey

colors.gray = _objectSpread({}, colors.grey);
colors.defaults.gray = colors.defaults.grey;
module.exports = colors;